module.exports = __webpack_public_path__ + "img/family-icon.e3deff92.svg";